import React from 'react';

const Button = ({ children, variant = 'primary', size = 'md', className = '', href, type, disabled, ...props }) => {
  const baseClasses = [
    'inline-flex justify-center items-center font-semibold rounded-lg',
    'transition-all duration-200 ease-smooth',
    'focus:outline-none focus:ring-2 focus:ring-ifys-blue focus:ring-offset-2 focus:ring-offset-white',
    'enabled:hover:scale-[1.02] enabled:active:scale-[0.98]',
    'disabled:opacity-60 disabled:cursor-not-allowed',
    'will-change-transform',
  ].join(' ');

  const variants = {
    primary: 'bg-ifys-blue text-white shadow-sm enabled:hover:bg-ifys-dark-blue enabled:hover:shadow-md enabled:active:shadow-sm',
    secondary: 'bg-white text-ifys-blue border-2 border-ifys-blue shadow-sm enabled:hover:bg-ifys-blue enabled:hover:text-white enabled:hover:border-ifys-dark-blue enabled:hover:shadow-md enabled:active:shadow-sm',
  };

  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
  };

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} aria-disabled={disabled || undefined} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button type={type || 'button'} className={classes} disabled={disabled} {...props}>
      {children}
    </button>
  );
};

export default Button;
